import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import AdministratorsTableRow from './AdministratorsTableRow';
import { Permission } from "../../../../../../components/SessionInfo";
import OrderCell from "../../../../../../common/components/OrderCell/OrderCell";

const sticky = {
  position: 'sticky',
  top: 0,
  backgroundColor: '#fff'
};

function AdministratorsTable({ rows, roles, triggerRefetch, permission, ordersBundle }) {
  return (
    <TableContainer component={Paper} sx={{width: 'auto', boxShadow: 'none', height: '100%'}}>
      <Table sx={{minWidth: 650}}>
        <TableHead>
          <TableRow>
            <OrderCell ordersBundle={ordersBundle} label={'Фамилия'} orderField={'family_name'} sticky={sticky} />
            <OrderCell ordersBundle={ordersBundle} label={'Имя'} orderField={'first_name'} sticky={sticky} />
            <OrderCell ordersBundle={ordersBundle} label={'Отчество'} orderField={'patronymic'} sticky={sticky} />
            <OrderCell ordersBundle={ordersBundle} label={'Должность'} orderField={'workPosition'} sticky={sticky} />
            <OrderCell ordersBundle={ordersBundle} label={'Логин'} orderField={'login'} sticky={sticky} />
            <OrderCell ordersBundle={ordersBundle} label={'Роль'} orderField={'role'} sticky={sticky} />
            <OrderCell ordersBundle={ordersBundle} label={'Email'} orderField={'email'} sticky={sticky} />
            <TableCell sx={sticky}>Уведомлять о лицензии</TableCell>
            <TableCell sx={sticky}>Уведомлять о ключах</TableCell>
            <TableCell sx={sticky}>Ключи</TableCell>
            <TableCell sx={sticky}>Активен</TableCell>
            {(permission === Permission.WRITE) ? <TableCell sx={sticky}></TableCell>: ''}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (<AdministratorsTableRow permission={permission} row={row} roles={roles} triggerRefetch={triggerRefetch} key={row.id} />))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default AdministratorsTable;
